import { Dashboard as DashboardIcon, Storefront as StorefrontIcon, Groups as GroupsIcon, MenuBook as MenuBookIcon, Brush as BrushIcon, Sell as SellIcon, WorkspacePremium as WorkspacePremiumIcon, Category as CategoryIcon, QrCode as QrCodeIcon, Loyalty as LoyaltyIcon} from '@mui/icons-material';

export const MenuItems = (t) => [
  {
    type: "menu",
    text: t('menu_drawer_text_branchoffices'),
    icon: <StorefrontIcon />,
    to: "/admin/sucursales",
    role: ["SUPERADMIN"]
  },
  {
    type: "menu",
    text: t('menu_drawer_text_users'),
    icon: <GroupsIcon />,
    to: "/admin/usuarios",
    role: ['SUPERADMIN']
  },
  {
    type: "menu",
    text: t('menu_drawer_text_labels'),
    icon: <SellIcon />,
    to: "/admin/etiquetas-producto",
    role: ["SUPERADMIN", 'ADMIN']
  },
  {
    type: "divider",
  },
  {
    type: "menu",
    text: t('menu_drawer_text_dashboard'),
    icon: <DashboardIcon />,
    to: "/admin/dashboard",
    role: ["SUPERADMIN", 'ADMIN', "MKT", "DESIGN"]
  },
  {
    type: "menu",
    text: t('menu_drawer_text_menus'),
    icon: <MenuBookIcon />,
    to: "/admin/menus",
    role: ["SUPERADMIN", 'ADMIN', "DESIGN"]
  },
  {
    type: "menu",
    text: t('menu_drawer_text_design'),
    icon: <BrushIcon />,
    to: "/admin/menu-disenio",
    role: ["SUPERADMIN", 'ADMIN']
  },
  {
    type: "menu",
    text: t('menu_drawer_text_qrcode'),
    icon: <QrCodeIcon />,
    to: "/admin/codigos-qr",
    role: ["SUPERADMIN", 'ADMIN', "DESIGN"]
  },
  {
    type: "menu",
    text: t('menu_drawer_text_builder'),
    icon: <CategoryIcon />,
    to: "/admin/constructor",
    role: ["SUPERADMIN", 'ADMIN', "DESIGN"]
  },
  {
    type: "menu",
    text: t('menu_drawer_text_promotions'),
    icon: <WorkspacePremiumIcon />,
    to: "/admin/promociones",
    role: ["SUPERADMIN", 'ADMIN', "MKT", "DESIGN"]
  },
  {
    type: "menu",
    text: t('menu_drawer_text_pricing'),
    icon: <LoyaltyIcon />,
    to: "/admin/subscripciones",
    role: ["SUPERADMIN", 'ADMIN', "MKT", "DESIGN"]
  },
  {
    type: "divider",
  }
]